<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
import fun from "@/common/js/common";

export default {
  name: "App",
  provide() {
    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
      adid: "102000", // 广告id
      ref:"user"
    };
  },
  watch: {},
  created() {
    // if (window.location.href.indexOf("adid") === -1) {
    //   // console.log(localStorage.getItem("adid")=='null')--》true  导致获取localStorage中adid有可能为null--》bug  补充完整
    //   this.adid = localStorage.getItem("adid") && localStorage.getItem("adid")!='null'?localStorage.getItem("adid"):this.adid;
    //   window.location.href =
    //     (window.location.href.indexOf("?") === -1
    //       ? window.location.href
    //       : window.location.href.split("?")[0]) +
    //     "?adid=" +
    //     this.adid;
    //     localStorage.setItem("adid", this.adid);

    // } else {
    //    this.adid = fun.getQueryString("adid");
    //    this.ref = fun.getQueryString("ref");
    //    localStorage.setItem("adid", fun.getQueryString("adid"));
    //    localStorage.setItem("ref", fun.getQueryString("ref"));
    // }
    var str = navigator.userAgent.toLowerCase();
    var ver = str.match(/cpu iphone os (.*?) like mac os/);
    let systemNub = "";
    if(ver && Array.isArray(ver)){
      systemNub = ver[1].replace(/_/g, ".").split('.')[0];
      localStorage.setItem("systemNub",systemNub);
    }
    let href = window.location.href;
    let idx = href.indexOf("/index");//可以换成其他条件，可以不用的，已经有adid的判断了
    // let idx = href.indexOf("test");//测试
    if (window.location.href.indexOf("adid") === -1) {
       if(localStorage.getItem("ios-wechat-url")){
        let href = localStorage.getItem("ios-wechat-url");
        window.location.href = href;
        localStorage.removeItem("ios-wechat-url");
        this.adid = fun.getQueryString("adid");
        this.ref = fun.getQueryString("ref");
        localStorage.setItem("adid", fun.getQueryString("adid"));
        localStorage.setItem("ref", fun.getQueryString("ref"));
      }else if(systemNub>=15 && idx<0){
        console.log("需要请求接口获取url");
        this.getGameUrl()
      }else{
        this.adid = localStorage.getItem("adid") && localStorage.getItem("adid")!='null'?localStorage.getItem("adid"):this.adid;
        window.location.href =
          (window.location.href.indexOf("?") === -1
            ? window.location.href
            : window.location.href.split("?")[0]) +
          "?adid=" +
        this.adid;
        localStorage.setItem("adid", this.adid);
      }
    } else{
      this.adid = fun.getQueryString("adid");
      this.ref = fun.getQueryString("ref");
      localStorage.setItem("adid", fun.getQueryString("adid"));
      localStorage.setItem("ref", fun.getQueryString("ref"));
    }
  },
  mounted() {

  },
  methods: {
    getGameUrl() {
      this.$http.post(fun.apiUrl + "api/common/ios/getLink").then(
        function (res) {
          if (res.body.code === 200 && res.body.data.iosLink) {
            window.location.href = res.body.data.iosLink;
          }
        },
        function (res) {}
      );
    },
    //页面刷新
    reload() {
      this.isRouterAlive = false; //先关闭，
      this.$nextTick(function () {
        this.isRouterAlive = true; //再打开
      });
    },
  },
};
</script>

<style>
body {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}

#app {
  width: 100%;
  letter-spacing: 0.01rem;
  min-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: #484545;
  font-size: 14px;
  position: absolute;
  left: 0;
  top: 0;
}

* {
  touch-action: pan-y;
}

/* #inner1 input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px rgba(239, 239, 239, 1) inset !important;
} */
.commonMask {
  max-width: 370px;
  width: 80%;
  height: 330px;
  background: #fff;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.headerTite {
  height: 50px;
  font-weight: bold;
  font-size: 16px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: stretch;
}

.headerTite_l,
.headerTite_r,
.headerTite_m {
  width: 55px;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.headerTite_m {
  flex: 1;
}

.headerTite_l img,
.headerTite_r img,
.headerTite_m img {
  width: 15px;
  height: 15px;
}

.bindPhone {
  height: 40px;
  background: #ff884e;
  color: #fff;
  width: 90%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.nut-dialog {
  width: 40%;
  max-height: 3rem;
}

.nut-dialog-ok {
  background: linear-gradient(315deg, #12cdb0 0%, #12cdb0 100%);
}

.inner2 input {
  outline: none;
  border: none;
  background-color: transparent !important;
  color: #9131c8;
   -webkit-text-fill-color: #9131c8;
}
.inner6 input{
  color: #FF913A;
   -webkit-text-fill-color: #FF913A;
}
.inner8 input{
  color: #838383;
   -webkit-text-fill-color: #838383;
}
.inner10 input{
  color: #838383;
   -webkit-text-fill-color: #838383;
}
.inner2 .page_win{
  font-family: Microsoft YaHei;
  width: 5.92rem;
  /* height: 5.4rem; */
  padding: 0.12rem 0.26rem 0.2rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: none;
  align-items: stretch;
  background: #fff;
  border-radius: 0.1rem;
  color: #9131c8;
}
.inner6 .bindPhoneWin{
  height: auto;
  padding: 0.12rem 0.26rem 0.4rem;
}
.inner6 .renzhengWin,.inner6 .accountPwd {
  height: auto;
}
.inner6 .page_win{
  color:#FF913A ;
}


.inner10 .bindPhoneWin{
  height: auto;
  padding: 0.12rem 0.26rem 0.4rem;
}
.inner10 .renzhengWin,.inner10 .accountPwd {
  height: auto;
}
.inner10 .page_win{
  color:#12CDB0 ;
}


.inner2 .bot_btn{
  width: 100%;
  margin: 0.36rem auto 0;
  height: 0.8rem;
  background-color: #9131c8;
  color:#fff;
  font-size: 0.3rem;
  font-weight: bold;
  letter-spacing: 2px;
  border-radius: 0.1rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.inner6 .bot_btn{
  height: 0.7rem;
  background-color: #FF913A;
}
.inner8 .bot_btn{
  height: 0.8rem;
  background-color: #FF913A;
  margin-top: .16rem;
}
.inner10 .bot_btn{
  height: 0.8rem;
  background-color: #12CDB0;
  margin-top: .16rem;
}
.inner2 .view_group_l{
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: none;
  align-items: center;
}
.inner2 .view_group_l input {
  flex: 1;
  max-width: 4rem;
  background-color: transparent;
}
.inner2 .view_group_l .codeInput {
  max-width: 2.3rem;
}
.inner2 .view_group_l img {
  margin-right: 0.24rem;
}
.inner2 .view_group_l .account_icon {
  width: 0.37rem;
  height: 0.42rem;
}
.inner2 .view_group_l .pwd_icon {
    width: 0.36rem;
    height: 0.38rem;
}
.inner2 .view_group_l .phone_icon {
  width: 0.32rem;
  height: 0.42rem;
}
.inner2 .view_group_l .code_icon {
  width: 0.44rem;
  height: 0.40rem;
}
.inner2 .view_group_r {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.inner2 .view_group_r img {
  width: 0.28rem;
  height: 0.28rem;
}

</style>



// WEBPACK FOOTER //
// src/App.vue